import React, { Component } from "react";
import ConstantFontFamily from "../constants/FontFamily";
import {
    Animated,
    Dimensions,
    Image,
    ImageBackground,
    Platform,
    ScrollView,
    Text,
    TextInput,
    TouchableHighlight,
    TouchableOpacity,
    View,
    FlatList,
} from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Icon } from "react-native-elements";
import { connect } from "react-redux";
import { compose } from "recompose";
import {
    SearchClikVariables,
    SearchUserVariables
} from "../graphqlSchema/graphqlVariables/SearchVariables";
import applloClient from "../client";
import { fromJS, List } from "immutable";
import {
    SearchClikMutation,
    SearchUserMutation
} from "../graphqlSchema/graphqlMutation/SearchMutation";
import {
    UserFollowVariables,
    UserUnfollowVariables
} from "../graphqlSchema/graphqlVariables/FollowandUnfollowVariables";
import {
    UserFollowMutation
} from "../graphqlSchema/graphqlMutation/FollowandUnFollowMutation";
import { Hoverable } from "react-native-web-hooks";
import ButtonStyle from "../constants/ButtonStyle";
import { heightPercentageToDP as hp } from "react-native-responsive-screen";

class SearchInputComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            topic: '',
            clik: "",
            TopicList: [],
            ClikList: [],
            selectedCliks: {},
            selectedTopics: [],
            SelectedItem: {},
            FollowUserList: [],
            mergeList: [],
            focus: false,
            clikData: [],
            userData: [],
            mergeArray: []
        };
        this.escFunction = this.escFunction.bind(this);
    }


    escFunction(event) {
        if (event.key === "Escape") {
            this.handleSuggestionDelete()
            this.setState({ focus: false })

        }
    }

    getFollowUserList = items => {
        let FollowUserList = [];
        items.map(async (item) => {
            let index = 0;
            index = this.props.getUserFollowUserList.findIndex(
                i => {
                    //console.log(i.getIn(["user", "username"]).replace("user:", "") , item.getIn(["topic", "username"]));
                    return i.node.user.username == item.topic?.username &&
                        item.topic.username

                }
            );
            if (index != -1) {
                FollowUserList.push(item)
            }
        })
        this.setState({ FollowUserList: FollowUserList })

    }

    customRenderTopicSuggestion = async value => {
        //console.log(value);
        let topicsearchData = [];
        let cliksearchData = [];
        this.setState({ topic: value, clik: value });
        if (value.charAt(0) == "@") {
            this.setState({ mergeList: [] })
            SearchUserVariables.variables.prefix = value;
            applloClient
                .query({
                    query: SearchUserMutation,
                    ...SearchUserVariables,
                    fetchPolicy: "no-cache"
                })
                .then(res => {
                    res.data.search.users.forEach(async (element, index) => {
                        await topicsearchData.push({ topic: element });

                    });
                    if (value.length > 1) {
                        this.setState({ FollowUserList: [] })
                        this.getFollowUserList(topicsearchData)
                    } else {
                        let followList = []
                        this.props.getUserFollowUserList.map(e => {
                            followList.push({ topic: e.node.user })
                        })
                        this.setState({ FollowUserList: followList })
                    }

                    this.setState({ TopicList: topicsearchData });
                });
        } else if (value.charAt(0) == "#") {
            console.log(value, 'value');
            this.setState({ mergeList: [] })
            SearchClikVariables.variables.prefix = value;
            applloClient
                .query({
                    query: SearchClikMutation,
                    ...SearchClikVariables,
                    fetchPolicy: "no-cache"
                })
                .then(res1 => {
                    res1.data.search.cliks.forEach(async (element, index) => {
                        await cliksearchData.push({ clik: element });
                    });
                    this.setState({ ClikList: cliksearchData });
                });
        } else if (value.charAt(0) != "#" && value.charAt(0) != "@") {
            console.log(value, 'value222');
            this.setState({ mergeList: [] })
            SearchUserVariables.variables.prefix = value;
            applloClient
                .query({
                    query: SearchUserMutation,
                    ...SearchUserVariables,
                    fetchPolicy: "no-cache"
                })
                .then(res => {
                    res.data.search.users.forEach(async (element, index) => {
                        await topicsearchData.push({ name: element.username, id: element.id, profile_pic: element.profile_pic });

                    });
                    this.setState({ TopicList: topicsearchData });
                    this.getFollowUserList(topicsearchData)
                });
            SearchClikVariables.variables.prefix = value;
            applloClient
                .query({
                    query: SearchClikMutation,
                    ...SearchClikVariables,
                    fetchPolicy: "no-cache"
                })
                .then(res1 => {
                    res1.data.search.cliks.forEach(async (element, index) => {
                        // console.log(element, 'res1.data.search.clik')
                        const indexx = this.props.getUserFollowCliksList.findIndex(
                            i =>
                                i.node?.clik?.name
                                    .toLowerCase()
                                ==
                                element?.name
                                    .toLowerCase()

                        );
                        if (indexx != -1) {
                            this.state.ClikList.splice(element, 1);
                            await cliksearchData.push({ name: element.name, id: element.id, profile_pic: element.profile_pic, member_type: this.props.getUserFollowCliksList[indexx]?.node?.member_type });

                        } else {
                            await cliksearchData.push({ name: element.name, id: element.id, profile_pic: element.profile_pic, member_type: null });
                        }

                    });
                    this.setState({ ClikList: cliksearchData });

                    this.setState({ mergeList: [...topicsearchData, ...cliksearchData] })


                });
        }
    };

    componentDidMount = async () => {
        if (this.props.type == "clikProfile") {
            let clikName = this.props.cliksDetails.getIn(["data", "node"]) &&
                this.props.cliksDetails
                    .getIn(["data", "node"])
                    .get("name")

            let clikId = this.props.cliksDetails.getIn(["data", "node"]) &&
                this.props.cliksDetails
                    .getIn(["data", "node"])
                    .get("id")

            this.props.getUserFollowCliksList.forEach(e => {
                if (e.node.clik.name.toLowerCase() == clikName.toLowerCase()) {
                    if (e.node.member_type == "ADMIN" || e.node.member_type == "SUPER_ADMIN" || e.node.member_type == "MEMBER") {
                        this.setState({
                            mergeArray: [...this.state.mergeArray, { name: clikName, id: clikId, member_type: null }],
                        })
                    }
                }
            })


            this.props.setCancel(false)

        }
        this.props.SearchComment.current.focus()
        document.addEventListener("keydown", this.escFunction, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    componentDidUpdate = async (prevProps, prevState) => {
        //console.log( (prevState.selectedCliks != this.state.selectedCliks && prevState.selectedCliks.name != this.state.selectedCliks.name) || prevState.selectedTopics.length != this.state.selectedTopics.length);
        if ((prevState.selectedCliks != this.state.selectedCliks && prevState.selectedCliks.name != this.state.selectedCliks.name) || prevState.selectedTopics.length != this.state.selectedTopics.length) {
            let newObj = Object.assign([], this.state.selectedTopics);
            newObj.selectedCliks = Object.assign({}, this.state.selectedCliks)
            newObj.selectedUser = Object.assign([], newObj.selectedUser, this.state.selectedTopics)
            this.props.click(newObj)
        }

        if (prevState.mergeArray != this.state.mergeArray) {
            let newArray = this.state.mergeList
            this.state.mergeArray.forEach(e => {
                newArray.map((a, i) => {
                    if (e.name == a.name) {
                        newArray.splice(i, 1)

                    }

                })
            })
            setTimeout(() => {
                this.setState({ mergeList: newArray })

            }, 1000)

        }



        if (this.props.loginStatus == 1) {


            let previousClik = prevProps?.cliksDetails?.getIn(["data", "node"])
                ?.get("name")

            let currentClik = this.props?.cliksDetails
                ?.getIn(["data", "node"])
                ?.get("name")

            if (previousClik != currentClik) {
                this.setState({
                    mergeArray: [],
                })
                if (this.props.type == "clikProfile") {
                    let clikName = this.props.cliksDetails.getIn(["data", "node"]) &&
                        this.props.cliksDetails
                            .getIn(["data", "node"])
                            .get("name")

                    let clikId = this.props.cliksDetails.getIn(["data", "node"]) &&
                        this.props.cliksDetails
                            .getIn(["data", "node"])
                            .get("id")

                    this.props.getUserFollowCliksList.forEach(e => {
                        if (e.node.clik.name.toLowerCase() == clikName.toLowerCase()) {
                            if (e.node.member_type == "ADMIN" || e.node.member_type == "SUPER_ADMIN" || e.node.member_type == "MEMBER") {
                                this.setState({
                                    mergeArray: [{ name: clikName, id: clikId, member_type: null }],
                                })
                            }
                        }
                    })
                    this.props.setCancel(false)

                }

            }

        }

        // if (this.state.topic.length > 0) {
        //     this.setState({ mergeList: [] })
        // }


    }

    handleTopicSelectInput = (topic, id) => {
        let data = [{ name: topic, id: id }]
        // data.push({ name: topic, id: id })
        this.props.close(false)
        if (this.state.selectedTopics.length < 3) {
            let index = this.state.selectedTopics.findIndex(i => i.name == topic);
            if (index != -1) {
                alert("topic name already selected");
            } else {
                this.setState({
                    selectedTopics: this.state.selectedTopics.concat([topic]),
                    topic: topic,
                    clik: "",
                    TopicList: [],
                    ClikList: []
                });
            }
            console.log(data,'data');
            this.props.setUserData([...data])

        } else {
            alert("You can only choose Maximum 3 Topics to Tag");
            this.setState({
                topic: ""
            });
        }

        setTimeout(() => {
            this.setState({ focus: true })
            this.props.SearchComment.current.focus()
        }, 200);
    };



    handleItemDelete = (index) => {
        let tagsSelected = this.state.mergeArray
        tagsSelected.splice(index, 1)
        this.setState({ mergeArray: tagsSelected })
    }

    handleElements = (data, id, member_type) => {
        // console.log(id, 'iddddd');
        if (id.startsWith("C")) {
            this.handleClikSelectInput(data, id, member_type)
        } else if (id.startsWith("U")) {
            this.handleUserSelectInput(data, id)
        }
    }


    handleClikSelectInput = (clik, id, member_type) => {
        let data = [{ name: clik, id: id}]
        // data.push({ name: clik, id: id})
        console.log(clik, 'clik');
        if (this.state.clikData.length < 3) {
            let index = this.state.clikData.findIndex((i) => i.name == clik);
            if (index != -1) {
                alert("clik name already selected");
            } else {

                this.setState({
                    topic: "",
                    // clikData: this.state.clikData.concat([{ name: clik }]),
                    mergeArray: [...this.state.mergeArray, { name: clik, id: id, member_type: member_type }],
                    TopicList: [],
                    ClikList: [],
                    // UserList: []
                })
            }
        } else {
            alert("You can only choose Maximum 3 Cliks to Tag");
            setClikList('')

        }
        // console.log(data, 'clikssss');
        this.props.setClikData([...data])
        setTimeout(() => {
            this.setState({ focus: true })

            this.props.SearchComment.current.focus()

        }, 200);
    };

    handleUserSelectInput = (user, id) => {
        let data= [{ name: user, id: id }]
        // data.push({ name: user, id: id })
        if (this.state.userData.length < 3) {
            let index = this.state.userData.findIndex((i) => i.name == user);
            if (index != -1) {
                alert("user name already selected");
            } else {
                this.setState({
                    topic: "",
                    // userData: this.state.clikData.concat([{ name: user }]),
                    mergeArray: [...this.state.mergeArray, { name: user, id: id }],
                    TopicList: [],
                    ClikList: [],
                    UserList: [],
                })
            }
        }
        // console.log(this.state.mergeArray, 'user');
        this.props.setUserData([...data])

        setTimeout(() => {
            this.setState({ focus: true })
            this.props.SearchComment.current.focus()
        }, 200);
    }

    getFocusArray = () => {
        let dataItem = []
        this.props.getUserFollowCliksList?.map(e => {
            if (e.node.member_type != null) {
                dataItem.push({ name: e.node.clik.name, id: e.node.clik.id, profile_pic: e.node.clik.profile_pic, member_type: e.node.member_type })
            }
        })
        this.props.getUserFollowUserList?.slice(0, 2).map(e => {
            dataItem.push({ name: e.node.user.username, id: e.node.user.id, profile_pic: e.node.user.profile_pic })
        })
        this.setState({ mergeList: dataItem })
    }


    handleSuggestionDelete = () => {

        if (this.props.type == "clikProfile") {
            this.setState({ mergeList: [] })
        } else {

            this.setState({
                mergeList: [],
                ClikList: [],
                TopicList: [],
                mergeArray: [],
                topic: ""

            })

        }

        this.props.setSearchInput(false)

    }



    render() {
        
        return (
            <View style={{ flexDirection: "column", borderRadius: 6, width: "100%" }}>
                {this.state.focus && <ScrollView
                    nestedScrollEnabled
                    style={{
                        height: 140, zIndex: 999,
                        bottom: 40,
                        position: 'absolute',
                        backgroundColor: '#fff',
                        paddingLeft: 10,
                        // width: this.props.type == "dashboard" ? 450 : this.props.type == "topicPrfoile" ? 390 : this.props.type == "userProfile" || this.props.type == "external" ? 390 : 410,
                        width: "100%",
                        borderRadius: 20,


                    }}
                    showsVerticalScrollIndicator={false}
                >

                    {
                        this.state.mergeList.map((item, index) => {
                            // console.log(item,'iiiiiiiiiiii');
                            let Bgcolor = ""
                            let color = ""
                            if (item.id.startsWith("Clik")) {
                                Bgcolor = "#fff"
                                color = "#000"
                            } else if (item.id.startsWith("User")) {
                                Bgcolor = "#fff"
                                color = "#000"
                            } else {
                                Bgcolor = "#fff"
                                color = "#000"
                            }
                            return (
                                <View
                                    key={item.name}
                                    style={{
                                        width: "100%",
                                        // paddingVertical: 5,
                                        flexDirection: 'row',
                                    }}
                                // onPress={()=>console.log('this is hitting')}

                                >

                                    <Image
                                        source={{
                                            uri:
                                                item.id.startsWith("Clik") ?
                                                    item.profile_pic == null ? "data:image/png;base64,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" : item.profile_pic :
                                                    item.id.startsWith("User") ?
                                                        (item.profile_pic != null) ? item.profile_pic :
                                                            require("../assets/image/default-image.png") :
                                                        "data:image/png;base64,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",
                                        }}
                                        style={{
                                            width: 30,
                                            height: 30,
                                            borderRadius: item.id.startsWith("User") ? 15 : 5,
                                        }}
                                    />
                                    <View style={[item.id.startsWith("Clik") ?
                                        ButtonStyle.clikNameBackgroundStyle : item.id.startsWith("User") ? ButtonStyle.userNameBackgroundStyle : null, {
                                        marginLeft: 10,
                                    }]}>
                                        <Text
                                            style={[item.id.startsWith("Clik") ?
                                                ButtonStyle.clikNameTitleStyle : item.id.startsWith("User") ? ButtonStyle.userNameTitleStyle : null,
                                            {
                                                paddingHorizontal: 5
                                            }]}
                                            onPress={() => {

                                                if (item.id.startsWith("Clik")) {
                                                    this.handleElements(item.name, item.id, item.member_type)
                                                } else {
                                                    this.handleElements(item.name, item.id, null)
                                                }

                                            }}

                                        >
                                            {item.id.startsWith("Clik") ? "#" : item.id.startsWith("User") ? "@" : null}{item.name}
                                        </Text>
                                    </View>
                                </View>

                            );
                        })
                    }

                </ScrollView>

                }

                
                {this.state.topic.length > 0 && this.state.topic.startsWith('@') && (
                    <ScrollView
                        nestedScrollEnabled
                        style={{
                            height: 140, zIndex: 999,
                            bottom: 40,
                            position: 'absolute',
                            paddingLeft: 10,
                            backgroundColor: '#fff',
                            // width: this.props.type == "dashboard" ? 450 : this.props.type == "topicPrfoile" ? 390 : this.props.type == "userProfile" || this.props.type == "external" ? 390 : 410,
                            borderRadius: 20, width: "100%"

                        }}
                        showsVerticalScrollIndicator={false}
                    >



                        {this.state.FollowUserList.map((item, index) => {

                            return (
                                <View
                                    key={item.topic.username}
                                    style={{
                                        width: "100%",
                                        // paddingVertical: 5,
                                        flexDirection: 'row'
                                    }}
                                >

                                    {item.topic.profile_pic ? (<Image
                                        source={item.topic.profile_pic}
                                        style={{
                                            width: 30,
                                            height: 30,
                                            borderRadius: 15
                                        }}
                                    />) : (<Image
                                        source={require("../assets/image/default-image.png")}
                                        style={{
                                            width: 30,
                                            height: 30,
                                            borderRadius: 15
                                        }}
                                    />)}
                                    <View style={[ButtonStyle.userNameBackgroundStyle, {
                                        marginLeft: 10,
                                    }]}>
                                        <Text
                                            style={[ButtonStyle.userNameTitleStyle,
                                            {
                                                paddingHorizontal: 5
                                            }]}
                                            onPress={() => {
                                                // this.props.setUserData([...this.state.mergeArray, { name: user, id: id }])
                                                this.handleTopicSelectInput(
                                                    item.topic.username, item.topic.id
                                                )
                                            }
                                            }
                                        >
                                            @{item.topic.username}
                                        </Text>
                                    </View>

                                </View>
                            );
                        })}
                    </ScrollView>)
                }
                {this.state.topic.length > 1 && this.state.topic.startsWith('#') && (
                    <ScrollView
                        nestedScrollEnabled
                        style={{
                            height: 140, zIndex: 999,
                            bottom: 40,
                            position: 'absolute',
                            paddingLeft: 10,
                            backgroundColor: '#fff',
                            // width: this.props.type == "dashboard" ? 450 : this.props.type == "topicPrfoile" ? 390 : this.props.type == "userProfile" || this.props.type == "external" ? 390 : 410,
                            borderRadius: 20, width: "100%"

                        }}
                        showsVerticalScrollIndicator={false}
                    >


                        {this.state.ClikList.map((item, index) => {
                            // console.log(item, 'itemmm');
                            let indexx = this.props.getUserFollowCliksList.findIndex(
                                i =>
                                    i.node.clik.name.toLowerCase() ==
                                    item.clik.name.toLowerCase()
                            );

                            if (
                                indexx != -1 &&
                                (this.props.getUserFollowCliksList[indexx].node.member_type
                                    == "SUPER_ADMIN" ||
                                    this.props.getUserFollowCliksList[indexx].node.member_type == "ADMIN" ||
                                    this.props.getUserFollowCliksList[indexx].node.member_type == "MEMBER")
                            ) {
                                return (
                                    <TouchableOpacity
                                        key={item.clik.name}
                                        style={{
                                            width: "100%",
                                            paddingVertical: 5,
                                            flexDirection: 'row'
                                        }}
                                        onPress={() =>
                                            this.handleClikSelectInput(
                                                item.clik.name, item.clik.id, this.props.getUserFollowCliksList[indexx].member_type
                                            )
                                        }
                                    >



                                        <Image
                                            //source={require("../assets/image/default-image.png")}
                                            source={{ uri: item.clik.profile_pic == null } ? "data:image/png;base64,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" : item.clik.profile_pic}
                                            style={{
                                                width: 30,
                                                height: 30,
                                                borderRadius: 15
                                            }}
                                        />
                                        <View style={[
                                            ButtonStyle.clikNameBackgroundStyle, {
                                                marginLeft: 10,
                                            }]}>
                                            <Text
                                                style={[
                                                    ButtonStyle.clikNameTitleStyle,
                                                    {
                                                        paddingHorizontal: 5
                                                    }]}
                                            >
                                                #{item.clik.name}
                                            </Text>
                                        </View>

                                    </TouchableOpacity>
                                );
                            }
                        })}



                    </ScrollView>
                )}


                {/* </View> */}
                <View style={{
                    width: "100%",
                    // borderWidth:1,
                    // height: 40,
                    justifyContent: "flex-start",
                    flexDirection: "row",
                    alignItems: 'center',
                    paddingLeft: 12,

                }}>
                    <Icon
                        iconStyle={{
                            // position: "absolute",
                            // left: 8,
                            // marginRight: 10,
                            color: 'black',
                        }}
                        name="search"
                        size={18}
                        type="font-awesome"
                    />
                    <View style={{ flexDirection: 'row', justifyContent:"center", alignItems: 'center', width: "90%", }}>
                        {this.state.mergeArray && this.state.mergeArray.map((item, i) => {
                            let Bgcolor = ""
                            let color = ""
                            if (item.id.startsWith("Clik")) {
                                Bgcolor = "#E8F5FA"
                                color = "#4169e1"
                            } else if (item.id.startsWith("User")) {
                                Bgcolor = "#fff"
                                color = "#000"
                            }
                            return (
                                <TouchableOpacity style={[
                                    item.id.startsWith("Clik") ?
                                        ButtonStyle.clikNameBackgroundStyle : item.id.startsWith("User") ? ButtonStyle.userNameBackgroundStyle : null, {
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        marginVertical: 2,
                                        marginLeft: 10,
                                        justifyContent: "space-between",
                                        borderWidth: item.id.startsWith("User") ? 1 : 0,
                                        borderColor: item.id.startsWith("User") ? '#000' : 'transparent',
                                    }]}
                                    key={i}

                                >
                                    <Text
                                        style={[item.id.startsWith("Clik") ?
                                            ButtonStyle.clikNameTitleStyle : item.id.startsWith("User") ? ButtonStyle.userNameTitleStyle : null, {
                                            width: "100%",
                                            paddingHorizontal: 5
                                        }]}
                                    >
                                        {item.id.startsWith("Clik") ? "#" : item.id.startsWith("User") ? "@" : null}{item.name}

                                    </Text>
                                    <Icon
                                        color={
                                            color
                                        }
                                        name="close"
                                        type="antdesign"
                                        size={16}
                                        // iconStyle={{ marginLeft: 5 }}
                                        onPress={() => this.handleItemDelete(i)}
                                    />
                                </TouchableOpacity>
                            )
                        })}


                        <TextInput
                            value={this.state.topic}
                            autoFocus={this.state.mergeArray.length > 0 ? true : false}
                            placeholder={this.state.mergeArray.length == 0 ? "Start discussion with /cliks or @users " : null}
                            placeholderTextColor='grey'
                            onChangeText={topic => {
                                this.customRenderTopicSuggestion(topic);
                                if (this.state.topic.startsWith("@") && this.state.topic.startsWith("#")) {
                                    this.setState({ mergeList: [] })
                                }
                            }
                            }
                            ref={this.props.SearchComment}
                            onFocus={() => {
                                this.setState({ focus: true })
                                setTimeout(() => {
                                    this.getFocusArray()

                                }, 150);
                                this.props.setCancel(true)
                            }}
                            onBlur={() => {
                                setTimeout(() => {
                                    this.setState({ focus: false })
                                }, 200);
                                this.props.setCancel(false)

                            }}
                            style={{
                                height: this.state.focus && this.state.mergeArray.length > 0 ? 20 : 40,
                                // paddingHorizontal: 5,
                                // width: this.state.mergeArray.length > 0 ? 100 : 400,
                                width: '100%',
                                paddingLeft: Dimensions.get('window').width <= 750 ? 25 : 20,
                                fontWeight: 'bold',
                                fontFamily: ConstantFontFamily.defaultFont,
                                outline: 'none',

                            }}
                        />


                    </View>

                    <Icon
                        name="close" size={18} type="font-awesome"
                        iconStyle={{ marginLeft: 5 }}
                            //  this.props.type == "dashboard" ? 5 : this.props.type == "topicPrfoile" ?  : this.props.type == "userProfile" || this.props.type == "external" ? 50 : 70 }}
                        onPress={() => this.handleSuggestionDelete()}

                    />

                </View>

            </View>
        );
    }
}


const mapStateToProps = state => {
    return ({
        term: state.ScreenLoadingReducer.get("setTerm"),
        getUserFollowCliksList: state.LoginUserDetailsReducer.userFollowCliksList,
        getUserFollowUserList: state.LoginUserDetailsReducer.userFollowUserList
            ? state.LoginUserDetailsReducer.userFollowUserList
            : [],
        cliksDetails: state.TrendingCliksProfileReducer.get(
            "getTrendingCliksProfileDetails"
        ),
        loginStatus: state.UserReducer.get("loginStatus"),

    })
};

const mapDispatchToProps = dispatch => ({
    setTerm: payload => dispatch({ type: "SET_TERM", payload })
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
    SearchInputComponent
);

